__turbopack_context__.v({
  "circle": "circledicon-module__vYpNsa__circle",
});
